import type { FC } from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { DynamicGrid } from "../../../dynamicGrid";

export const DateTimeInfo: FC<{ label: string; datetime: string }> = ({ label, datetime }) => {
  const { formattedDate, formattedTimeElapsed } = DynamicGrid.useFormattedDateTime(datetime);

  return (
    <Stack direction="row" spacing={3}>
      <Typography
        variant="body2"
        sx={{
          width: "50px",
          fontSize: theme => theme.typography.pxToRem(12),
          color: theme => theme.palette.text.secondary,
        }}
      >
        {label}
      </Typography>
      <Typography sx={{ fontSize: theme => theme.typography.pxToRem(12) }}>
        {formattedDate}
        <Box
          component="span"
          sx={{ ml: 1, fontVariantNumeric: "tabular-nums", color: theme => theme.palette.text.tertiary }}
        >
          ({formattedTimeElapsed})
        </Box>
      </Typography>
    </Stack>
  );
};
